import packageJson from "../../package.json";

export const environment = {
  production: false,
  title: 'Dev Environment Heading',
  apiURL: 'https://project-chrono-dev.metadrop.pro',
  client_id: 'default_consumer',
  client_secret: 'q5SECphG',
  appVersion: packageJson.version
};
